import { useReducer } from "react";

export type BestAvailableTypeState = Record<string, number>;

export enum BestAvailableTypeActions {
  SET_TYPE,
  REMOVE_TYPE,
}

export type BestAvailableTypeAction = {
  type: BestAvailableTypeActions;
  payload: { id: number; quantity?: number };
};

export function bestAvailableTypeReducer(
  prevState: BestAvailableTypeState,
  action: BestAvailableTypeAction
): BestAvailableTypeState {
  const { type, payload } = action;

  switch (type) {
    case BestAvailableTypeActions.SET_TYPE:
      return { ...prevState, [payload.id]: payload.quantity ?? 0 };
    case BestAvailableTypeActions.REMOVE_TYPE: {
      const newState = { ...prevState };
      delete newState[payload.id];
      return newState;
    }
    default:
      return prevState;
  }
}

export function useBestAvailableTypeState(
  initialSelectedTypes?: BestAvailableTypeState
) {
  const [bestAvailableTypeState, dispatch] = useReducer(
    bestAvailableTypeReducer,
    initialSelectedTypes ?? {}
  );

  return { bestAvailableTypeState, dispatch };
}
